// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import MobiusLink, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    destination = "destination",
    overrideTitle = "overrideTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.destination]: LinkFieldValue;
        [fields.overrideTitle]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        drawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
    };
};

const mapDispatchToProps = {
    setNavDrawerIsOpen,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface HeaderLinkStyles {
    wrapperLink?: InjectableCss;
    headerLink?: LinkPresentationProps;
}

export const headerlinkStyles: HeaderLinkStyles = {
    wrapperLink: {
        css: css`
            padding: ${pxToRem(10, 20)};
        `,
    },
    headerLink: {
        color: "white",
        icon: {
            iconProps: {
                src: ChevronRight,
            },
            position: "right",
        },
        css: css`
            width: 100%;
            justify-content: space-between;
        `,
    },
};

const styles = headerlinkStyles;

const HeaderLink: FC<Props> = props => {
    const { title, url } = useGetLink(props.fields.destination);

    const closeDrawer = () => {
        props.setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => props.setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    if (!url) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapperLink}>
            <MobiusLink onClick={closeDrawer} {...styles.headerLink} href={url}>
                {props.fields.overrideTitle || title || url}
            </MobiusLink>
        </StyledWrapper>
    );
};

const headerlink: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(HeaderLink),
    definition: {
        group: "Header",
        icon: "Link",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.destination,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.overrideTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default headerlink;
